const storeKey = "perkxiinterpolation";

/**
 * @deprecated
 * @description This function is deprecated and should not be used.
 */

const setStore = () => {
    sessionStorage.setItem(
        storeKey, JSON.stringify({
            data: null,
            basic: {},
            links: {},
            settings: {},
            placeholder: null
        })
    );
};

const fill = (key, data) => {
    if(sessionStorage.getItem(storeKey) == undefined) setStore();
    let store = sessionStorage.getItem(storeKey);
    store = JSON.parse(store);
    store[key] = data;
    sessionStorage.setItem(storeKey, JSON.stringify(store)); 
};

const fetch = (key) => {
    if(sessionStorage.getItem(storeKey) == undefined) setStore();
    let store = sessionStorage.getItem(storeKey);
    store = JSON.parse(store);

    return store[key];
};


const setLinks = ( property, value ) => {
    let store = sessionStorage.getItem(storeKey);
    store = JSON.parse(store);
    store['links'] = { ...store['links'] };
    store['links'][property] = value;
    sessionStorage.setItem(storeKey, JSON.stringify(store)); 
};

const setSettings = (property, value) => {
    let store = sessionStorage.getItem(storeKey);
    store = JSON.parse(store) || {};
    store['settings'] = { ...store['settings'] };
    if (typeof value === 'object' && !Array.isArray(value)) {
        store['settings'][property] = { 
            ...store['settings'][property], 
            ...value 
        };
    } else if (Array.isArray(value)) {
        store['settings'][property] = value;
    } else {
        store['settings'][property] = value;
    }
    sessionStorage.setItem(storeKey, JSON.stringify(store)); 
};

export const storePerkXiInterpolation = {
    fill,
    fetch,
    setLinks,
    setSettings
};